import {
  V46_FONT_PROFILES,
  V46FontLibrary,
  bindV46FontLibraryToBrowser,
  createDefaultBrowserFontEnvironment,
  type BrowserFontEnvironment,
} from '@dg-embalajes/font-library';
import { editorFontByteSource } from './fontByteSource';

export const v46FontLibrary = new V46FontLibrary(editorFontByteSource);

let browserEnvironment: BrowserFontEnvironment | null = null;

export function getBrowserFontEnvironment(): BrowserFontEnvironment {
  browserEnvironment ??= createDefaultBrowserFontEnvironment();
  return browserEnvironment;
}

export const v46EditorFontResolver = {
  ensureReady(family: string, options: { readonly sizePx: number; readonly sampleText: string }) {
    return bindV46FontLibraryToBrowser(v46FontLibrary, getBrowserFontEnvironment())
      .ensureReady(family, options);
  },
};

let allFontsPromise: Promise<void> | null = null;

export function ensureAllV46FontsReady(): Promise<void> {
  allFontsPromise ??= Promise.all(
    V46_FONT_PROFILES.map((profile) =>
      v46FontLibrary.ensureBrowserReady(profile.family, getBrowserFontEnvironment(), {
        sizePx: 32,
        sampleText: 'DG embalajes Tu marca 0123456789',
      }),
    ),
  ).then(() => undefined);
  return allFontsPromise;
}
